import QueryString from "qs"
import http from "../01_axios"
import {
  apiDeleteAccount,
  apiDeleteGroupAccount,
  apiDeleteMember,
  apiDeleteMemberGroup,
  apiExportAccountMember,
  apiExportUser,
  apiGetAccount,
  apiGetAccountFather,
  apiGetAllMember,
  apiGetChildAccountByParentID,
  apiGetGroupAccount,
  apiGetListMemberForGroup,
  apiInsertAccount,
  apiInsertGroupAccount,
  apiInsertMember,
  apiInsertMemberToGroup,
  apiResetPassword,
  apiUpdateByAccountID,
  apiUpdateGroupAccount,
  apiUpdateMember,
  apiUpdateSortOrder,
  apiInsertUserAssociation,
  apiGetMembersForCategory,
  apiGetMembersForCategoryNotInAssociation,
  apiInsertInvitedEmail
} from "./urls"

const updateSortOrder = data => http.post(apiUpdateSortOrder, data)
// Đơn vị
const getAccount = body => http.post(apiGetAccount, body)
const updateByAccountID = body => http.post(apiUpdateByAccountID, body)
const insertAccount = body => http.post(apiInsertAccount, body)
const deleteAccount = data => http.post(apiDeleteAccount, data)
const getAccountFather = data => http.post(apiGetAccountFather, data)
const exportUser = body =>
  http.post(apiExportUser, body, {
    responseType: "blob",
  })
//Nhóm đơn vị
const getGroupAccount = body => http.post(apiGetGroupAccount, body)
const insertGroupAccount = body => http.post(apiInsertGroupAccount, body)
const updateGroupAccount = body => http.post(apiUpdateGroupAccount, body)
const deleteGroupAccount = data => http.post(apiDeleteGroupAccount, data)
const getChildAccountByParentID = data =>
  http.get(apiGetChildAccountByParentID, data)
const getAllMember = body => http.post(apiGetAllMember, body)
const insertMember = body => http.post(apiInsertMember, body)
const updateMember = body => http.post(apiUpdateMember, body)
const deleteMember = data => http.post(apiDeleteMember, data)
const exportAccountMember = data =>
  http.post(apiExportAccountMember, data, {
    responseType: "blob",
  })
const resetPassword = params =>
  http.patch(`${apiResetPassword}?${QueryString.stringify(params)}`)
//Nhóm thành viên
const getListMemberForGroup = body => http.post(apiGetListMemberForGroup, body)
const insertMemberToGroup = data => http.post(apiInsertMemberToGroup, data)
const deleteMemberGroup = data => http.post(apiDeleteMemberGroup, data)
//Mời hội viên
const insertUserAssociation = data => http.post(apiInsertUserAssociation, data)
const getMembersForCategory = params =>
  http.get(`${apiGetMembersForCategory}?${QueryString.stringify(params)}`)
const getMembersForCategoryNotInAssociation = params =>
  http.get(`${apiGetMembersForCategoryNotInAssociation}?${QueryString.stringify(params)}`)
//Mời email
const insertInvitedEmail = body => http.post(apiInsertInvitedEmail, body);

const CategoryPostApi = {
  getChildAccountByParentID,
  updateSortOrder,
  getAccount,
  updateByAccountID,
  insertAccount,
  deleteAccount,
  exportUser,
  getAccountFather,
  getGroupAccount,
  insertGroupAccount,
  updateGroupAccount,
  deleteGroupAccount,
  getAllMember,
  insertMember,
  updateMember,
  deleteMember,
  exportAccountMember,
  resetPassword,
  getListMemberForGroup,
  insertMemberToGroup,
  deleteMemberGroup,
  insertUserAssociation,
  getMembersForCategory,
  getMembersForCategoryNotInAssociation,
  insertInvitedEmail
}
export default CategoryPostApi
